module.exports = __webpack_public_path__ + "img/work_share_bg.95f3772d.png";